// app/ui/src/store/slices/trackingHistorySlice.js
import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import api from '../../utils/api';

const initialState = {
  history: {},
  loading: false,
  error: null,
  pagination: {
    total: 0,
    pages: 1,
    current_page: 1,
    per_page: 100
  }
};

export const fetchTrackingHistory = createAsyncThunk(
  'trackingHistory/fetch',
  async ({ loadId, page = 1, perPage = 100 }) => {
    const response = await api.get(
      `/api/loads/${loadId}/tracking-history?page=${page}&per_page=${perPage}`
    );
    return response.data;
  }
);

const trackingHistorySlice = createSlice({
  name: 'trackingHistory',
  initialState,
  reducers: {
    addTrackingUpdate: (state, action) => {
      const { load_id, data } = action.payload;
      if (!state.history[load_id]) {
        state.history[load_id] = [];
      }
      state.history[load_id].unshift(data);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackingHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrackingHistory.fulfilled, (state, action) => {
        state.loading = false;
        const { tracking_history, pagination } = action.payload;
        state.history[action.meta.arg.loadId] = tracking_history;
        state.pagination = pagination;
      })
      .addCase(fetchTrackingHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { addTrackingUpdate } = trackingHistorySlice.actions;
export default trackingHistorySlice.reducer;

export const selectTrackingHistoryByLoadId = createSelector(
  [(state) => state.trackingHistory.history, (_, loadId) => loadId],
  (history, loadId) => history[loadId] || []
);